angular.module('filters').filter('filterInt', function() {
  return function(value) {
    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
      return Number(value);
    }
    return 0/0;
  };
});
